import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import Logo from './Logo'

import { ReactComponent as SiemensLogo } from '../static/logos/sie-logo-petrol-rgb.svg'
import { ReactComponent as IPLogo } from '../static/logos/ip.svg'

export default class About extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data: undefined
    }
  }

  render() {

    const renderIntroText = () => {
      return(

        <div className='section container'>
          <p className='has-text-warning has-text-centered has-text-weight-bold mb-3'>
          Versão de Demonstração
          </p>
          <p className='mx-3 has-text-justified'>
          A informação apresentada neste portal é apenas para efeitos de demostração de conceito e não pode ser utilizada para outros propósitos. Trade marks, copyrights, marcas, produtos e nomes de empresas relacionadas com produtos, bens  ou serviços são apenas para efeitos de demonstração (demo) e são propriedade dos respetivos donos. A Siemens Mobility Portugal não aceita qualquer responsabilidade por qualquer perda causada pela consequência direta ou indireta da utilização dos dados aqui apresentados nesta demo.
          </p>
        </div>
      )
    }

    const renderAbout = () => {

      return (
        <section className='section container mt-6'>

          <div className="container sie-title-container">
            <h5 className="title is-size-4">Sobre o e.coPortal</h5>
          </div>

          <div className='content'>

            <p className='mx-5 my-4 has-text-justified'>
              e.coPortal é um software abrangente de monitorização de consumo de energia em cada uma das subestações de tração. Pretende identificar o consumo de energia em conformidade com as passagens de composições de mercadorias e passageiros, utilizando como como baseline: 
            </p>

            <ul className='has-text-justified  pl-5'>
              <li>
            Consumos de energia registados em cada uma das subestações, em diagramas de carga registados em 15 minutos pertencentes ao ano 2019
              </li>
              <li>
            Informação dos horários pré-estabelecidos para o período em análise
              </li>
              <li>
            Informação SITRA com o detalhe dos atrasos relativos aos horários inicialmente estabelecidos;
              </li>
              <li>
            De forma a analisar de forma integrada a informação recolhida, em alguns momentos foi utilizada informação proveniente 
            portais de Comunicação Social (informação de greves, incidentes, etc.)
              </li>
            </ul>
	
          </div>
                      

          <div className="container sie-title-container mt-6">
            <h5 className="subtitle">Acuidade de Dados</h5>
          </div>

          <div className='content'>

            <p className='mx-5 my-4 has-text-justified'>
          As técnicas de construção matemática são baseadas em redes neuronais, regressões lineares, entre outros. 
          Por meio dessas técnicas, é possível descobrir padrões ou tendências ocultas nos dados. Porém, os resultados 
          não são padronizados – e são representados numericamente. 
              <br/><br/>
          O modelo aplicado pretende identificar de forma 
          preditiva os consumos energéticos de cada um dos comboios, durante a passagem na área de influência da 
          subestação de tração em análise. Os resultados da análise mostram a aplicação dos algoritmos desenvolvidos 
          e a construção do modelo analítico que melhor se adequa. 
              <br/><br/>
          Medir resultados com precisão é um requisito natural 
          para qualquer projeto de <i>advance analytics</i> e no âmbito deste projeto não é diferente. A questão prática é 
          garantir a assignação da energia consumida a cada um dos comboios, com uma eficácia real.
            </p>

            <p className='mx-5 my-4 has-text-justified'>
            O desafio da incerteza é aqui mensurável com as 
            seguintes premissas, com a qualidade dos dados a influenciar a sua caracterização. 
            A forma de erro calculada para a execução da aproximação que aqui se apresenta e de 
            forma que se possa assignar uma quantidade de energia consumida a cada comboio, 
            tem por base os seguintes pontos:
            </p>


            <ul className='has-text-justified pl-5'>

              <li>
            Total de comboios analisados: 5333
              </li>
              <li>
            Erro de processamento de dados:
              </li>
              <ul className='has-text-justified pl-5'>
                <li>
            Comboios identificados sem consumo: 1,56%
                </li>
                <li>
            Consumo na subestação sem comboio: 3,50%
                </li>
                <li>
            Origem:
                </li>
                <ul className='has-text-justified pl-5'>
                  <li>
            Diagramas de carga com registos para intervalos de 15 minutos;
                  </li>
                  <li>
            Desfasamento entre as dependências registadas no SITRA e a localização da zona neutra;
                  </li>
                  <li>
            Relógio do contador da subestação não sincronizado com o horário dos comboios
                  </li>
                </ul>
              </ul>
              {/* <li>
            Erro total na desagregação de energia:  (ainda em análise)%
              </li> */}

            </ul>

          </div>

          <div className="container sie-title-container mt-6">
            <h5 className="subtitle">Copyright</h5>
          </div>

          <p className='mx-5 my-4 has-text-justified'>
          Todos algoritmos utilizados neste para a a preparação, agregação e apresentação de dados apresentados neste site. Incluido e não limitado a know-how especifico, estruturas de dados e design.
          </p>

        </section>

      )
    }
    
    return (
      <div className='container'>

        <Logo />

        <div className='container mb-6'>
          <div className='columns has-text-centered is-vcentered'>
            <div className='column is-6'>
              <SiemensLogo width="200px" height="30px"/>           
            </div>
            <div className='column is-6'>
              <IPLogo width="200px"  />
            </div>
          </div>
        </div>

        {renderIntroText()}

        {renderAbout()}



      </div>
    )
  }
}
